/*
 * module for showing a list of all tasks assigned to the selected topic
 */

define([
  "marionette",
  "messaging/messenger",
  "./tasksListView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, TasksListView, TaskModel) {
  "use strict";

  var TasksListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tasksList";
      this.region = options.region;
      this.statusId = TaskModel.STATUS.NOT_STARTED;
      this._setUpVents();
    },
    show: function (tasks, visibleStatusId, topicTaskArea) {
      try {
        // if nothing selected in the area, should be undefined or null
        this.selectedTaskModel = Messenger.reqres.request("get:selected:task");
      } catch (e) {
        this.selectedTaskModel = null;
      }
      //if no visible status Id is given, go with the default of 0 (not started).
      //Only not started tasks will be shown
      if (visibleStatusId !== undefined && visibleStatusId !== null) {
        this.statusId = visibleStatusId;
      }
      this.tasks = tasks;
      var languages = Messenger.reqres.request("kb:languages");
      var languageIdToNameMap = {};
      languages.each(function (language) {
        languageIdToNameMap[language.get("id")] = language.get("name");
      });
      this.tasks.languageIdToNameMap = languageIdToNameMap;
      this.tasks.topicTaskArea = topicTaskArea;
      //attach the statusId with which we are filtering the tasks collection
      this.tasks.visibleStatusId = this.statusId;
      this.tasks.showAll = this.statusId === TaskModel.STATUS.ALL;
      //set a comparator for the tasks
      this.tasks.comparator = "dueDate";
      this.view = new TasksListView.tasksListView({ collection: this.tasks });
      //change which task is selected
      this.view.on(
        "itemview:selected:task",
        function (itemView) {
          //if a task was already selected, de-select it
          if (this.selectedTaskModel) {
            //we search by model in case the collection was re-rendered which would create new views
            this.view.children.findByModel(this.selectedTaskModel).deselectItem();
          }
          //keep track of the selected task model
          this.selectedTaskModel = itemView.model;
          //toggle the current task as selected
          itemView.selectItem();
          //trigger an event that a task was selected
          Messenger.vent.trigger("selected:task", this.selectedTaskModel);
        },
        this,
      );
      this.view.on(
        "render",
        function () {
          try {
            if (this.selectedTaskModel) {
              //we search by model in case the collection was re-rendered which would create new views
              this.view.children.findByModel(this.selectedTaskModel).selectItem();
            }
          } catch (e) {
            // Don't care if the select fails
            this.selectedTaskModel = null;
          }
        },
        this,
      );
      this.showRegion(this.view, { loading: true });
    },
    save: function () {
      this.tasks.saveCollection();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "deselect:task",
        function () {
          this.selectedTaskModel = null;
        },
        this,
      );
    },
  });

  return TasksListController;
});
